var lastScrollTop = 0;
let toshow = $('.header-wrapper img.fixed')
$(window).on('scroll',function(event){
   var st = $(this).scrollTop();
   if (st > 100){
		 // downscroll code
		 toshow.addClass('visible');
		 $(window).trigger('resize')
   } else {
		// upscroll code
		toshow.removeClass('visible');
	}
});


$('.menu-link-1').on('click', function(){
	$('.megamenu:not(.megamenu-1)').removeClass('show');
	$('.megamenu-1').addClass('show');
	$('#main').addClass('overlay');
})

$('.menu-link-2').on('click', function(){
	$('.megamenu:not(.megamenu-2)').removeClass('show');
	$('.megamenu-2').addClass('show');
	$('#main').addClass('overlay');
})

$('.menu-link-3').on('click', function(){
	$('.megamenu:not(.megamenu-3)').removeClass('show');
	$('.megamenu-3').addClass('show');
	$('#main').addClass('overlay');
})

$('.menu-link-4').on('click', function(){
	$('.megamenu:not(.megamenu-4)').removeClass('show');
	$('.megamenu-4').addClass('show');
	$('#main').addClass('overlay');
})


$('#main').on('click', function(){
	$('.megamenu').removeClass('show');
	$('#main').removeClass('overlay');
})

$('.megamenu').on('click', function(){
	$('.megamenu').removeClass('show');
	$('#main').removeClass('overlay');
})
